import { Carriers } from '../constants/carriers';
import { Products } from '../constants/products';
import { UserOrganization } from '../constants/userOrganization';
import { ProductConfig } from './productConfig';

export class LgaElevatedRisk extends ProductConfig {
  getCarrier(): Carriers {
    return Carriers.LGA;
  }
  getProduct(): Products {
    return Products.ER;
  }
  availableToOrganization(org: UserOrganization): boolean {
    return [
      UserOrganization.LGA,
      UserOrganization.ETHOS,
      UserOrganization.INTEGRA,
    ].includes(org);
  }
  getColor(): string {
    return 'ErGreen';
  }
  hasRateClass(): boolean {
    return false;
  }
  hasDebits(): boolean {
    return false;
  }
  ETIAvailable(): boolean {
    return true;
  }
}
